export default "<div class=\"homeBody\">\n  <div>\n    <app-carousel [items]='brands'></app-carousel>\n  </div>\n  \n</div>\n"